import React, { Component } from 'react'
import { Row, Col} from "antd"
import UltimateLogo from './../images/UltimateLogo.png'
import './PDFContent.css'
const ref = React.createRef();

export default class PDFContent extends Component {
    render() {
        return (
            <div className="PDFContent">
                <div>
                            <img src={UltimateLogo} className="PDFContentLogo"/>
                            <div>
                                <span>All PCP Report</span><br />
                                <span>November 2021</span>
                            </div>
                        </div>
                <table className="table" id="my-table">
                    <table>

                    <tr>
                        <td>
                            adfasdfasfasdf
                        </td>
                    </tr>
                    </table>
                    
                        
                        
                      <thead>
                          <tr>
                              <th>#</th>
                              <th>Member PCP Effective Date</th>
                              <th>IPA Name</th>
                              <th>Member ID</th>
                              <th>Member Last Name</th>
                              <th>Member First Name</th>
                              <th>Member DOB</th>
                              <th>Address</th>
                              <th>City</th>
                              <th>State</th>
                              <th>Zip</th>
                              <th>Telephone</th>
                              <th>Plan</th>
                              <th>PCP ID</th>
                              <th>PCP NPI ID</th>
                              <th>PCP First Name</th>
                              <th>PCP Last Name</th>
                              <th>PCP Address</th>
                              <th>PCP City</th>
                              <th>PCP State</th>
                              <th>PCP Zip</th>
                              <th>PCP County </th>
                          </tr>
                      </thead>
                      <tbody className="tdata">
                          {
                              [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1].map((item, index) => (
                                  <tr className="tdata">
                              <td>
                                  {index+1}
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                              <td>
                                  td value
                              </td>
                          </tr>
                              ))
                          }
                      </tbody>
                      
                  </table>
            </div>
        )
    }
}
